import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import { IWorkflowStepDetails } from "../common/types";

export const SET_WORKFLOW_STEPS = 'SET_WORKFLOW_STEPS';
export const SET_WORKFLOW_STEPS_LOADING = 'SET_WORKFLOW_STEPS_LOADING';


export const getWorkflowSteps = (url: string) => {
    return async (dispatch, getState) => {
      try {
          if (getState().WorkflowQueues.WorkFlowStepsLoading == false && getState().WorkflowQueues.WorkFlowSteps == null) {
            dispatch(saveWorkflowStepLoading(true));
            await Api.get(url).then((res: ApiResponse<any>) => {
                if (res.ok) {
                  dispatch(saveWorkflowStepInfoToStore(res.data));
                } else {
                    throw res.originalError;
                }
              });
          } 
      } catch (ex) {
        console.error(ex);
      } finally {
        dispatch(saveWorkflowStepLoading(false));
      }
    };
  };
  
export const assignWorkflowItem = (url, stepItemId, assignToId) => {
  return async dispatch => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItemId,
        assignToUserId: assignToId
      }).then((result: ApiResponse<any>) => {
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

const saveWorkflowStepInfoToStore = (workflowStepDetails: IWorkflowStepDetails[]) => {
    return {
      type: SET_WORKFLOW_STEPS,
      value: workflowStepDetails
    };
};

const saveWorkflowStepLoading = (setLoading: boolean) => {
    return {
      type: SET_WORKFLOW_STEPS_LOADING,
      value: setLoading
    };
};